import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/BoilerMaster.css";
import Table from "../Homepage/Table";
import AddBoilerMaster from "./AddBoilerMaster";
import SearchBoilerMaster from "./SearchBoilerMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function BoilerMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Head", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [loading, setloading] = useState(false);
  const [boilerupdatedata, setboilerupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const [boilerId, setboilerId] = useState(null);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);

  function fetchboilerdata(boilerid) {
    setboilerupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Boiler/GetSingleBoiler?id=${boilerid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setboilerupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Boiler/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: boilerId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [x.id, x.head, x.description])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Boiler" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Boiler" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Boiler" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Boiler" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <>
      <section className="boiler-master">
        <h1>Boiler Master</h1>
        <blockquote className="boiler-master-forms">
          <AddMaster
            text="Add Boiler Master"
            setshowaddform={setshowaddform}
            settriggerupdate={settriggerupdate}
            setshowsearchform={setshowsearchform}
            permit={writePermission}
          />

          <SearchMaster
            text="Search Boiler Master"
            setshowsearchform={setshowsearchform}
            setshowaddform={setshowaddform}
          />
        </blockquote>
        {showaddform && (
          <AddBoilerMaster
            setshowaddform={setshowaddform}
            reload={reload}
            setReload={setReload}
            triggerupdate={triggerupdate}
            boilerupdatedata={boilerupdatedata}
            key={`${boilerupdatedata?.id}-${triggerupdate}-${datareload}`}
          />
        )}
        {showsearchform && (
          <SearchBoilerMaster
            setshowsearchform={setshowsearchform}
            setpagenumber={setpagenumber}
            setIds={setIds}
            setBoilerId={setboilerId}
            setReload={setReload}
            setSearch={setSearch}
            reload={reload}
          />
        )}
        <Table
          tablehead={tablehead}
          tabledata={tabledata}
          setshowaddform={setshowaddform}
          url="Boiler/UpdateBoiler"
          settriggerupdate={settriggerupdate}
          fetchdata={fetchboilerdata}
          reload={reload}
          setReload={setReload}
          setdatareload={setdatareload}
          datareload={datareload}
          loading={loading}
          readPermission={readPermission}
          updatePermission={updatePermission}
          deletePermission={deletePermission}
          totalcount={totalcount}
        />
        <Pagination
          count={pagecount}
          setpagenumber={setpagenumber}
          pagenumber={pagenumber}
        />
      </section>
    </>
  );
}

export default BoilerMaster;
